import React from 'react';
import Spinner from './Spinner';

const variantStyles = {
  primary: 'bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-400 hover:to-primary-500 text-white shadow-xl shadow-primary-500/30 dark:from-primary-600 dark:to-primary-700 dark:hover:from-primary-500 dark:hover:to-primary-600',
  secondary: 'bg-slate-200 hover:bg-slate-300 text-slate-900 dark:bg-slate-700/60 dark:hover:bg-slate-700/80 dark:text-slate-200 dark:border dark:border-slate-600/50 dark:backdrop-blur-sm',
  outline: 'border-2 border-primary-500 text-primary-500 hover:bg-primary-50 dark:border-primary-400 dark:text-primary-400 dark:hover:bg-slate-800/60 dark:hover:border-primary-300',
  danger: 'bg-gradient-to-r from-red-600 to-red-700 hover:from-red-500 hover:to-red-600 text-white shadow-xl shadow-red-600/30 dark:from-red-700 dark:to-red-800 dark:hover:from-red-600 dark:hover:to-red-700',
  ghost: 'text-slate-600 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-300 dark:hover:bg-slate-800/60 dark:hover:text-slate-200',
  cta: 'bg-gradient-to-r from-primary-500 via-accent-600 to-primary-600 hover:from-primary-400 hover:via-accent-500 hover:to-primary-500 text-white shadow-xl shadow-primary-500/40 dark:from-primary-600 dark:via-accent-700 dark:to-primary-700 dark:hover:from-primary-500 dark:hover:via-accent-600 dark:hover:to-primary-600',
};

const sizeStyles = {
  sm: 'px-3 py-2 text-sm',
  md: 'px-4 py-2.5 text-base',
  lg: 'px-6 py-3 text-lg',
};

export default function Button({
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  icon: Icon = null,
  className = '',
  children,
  ...props
}) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 font-medium rounded-xl transition-all duration-200 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 focus-visible:dark:ring-primary-400 focus-visible:dark:ring-offset-slate-950 disabled:opacity-50 disabled:cursor-not-allowed';
  const variantClass = variantStyles[variant];
  const sizeClass = sizeStyles[size];
  const isDisabled = disabled || loading;

  return (
    <button
      className={`${baseStyles} ${variantClass} ${sizeClass} ${className}`}
      disabled={isDisabled}
      {...props}
    >
      {loading ? (
        <>
          <Spinner size="sm" />
          {children}
        </>
      ) : (
        <>
          {Icon && <Icon className="w-4 h-4" />}
          {children}
        </>
      )}
    </button>
  );
}
